import { __awaiter, __spreadArray, __generator } from '../node_modules/tslib/tslib.es6.mjs.js';
import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import en from '../lang/en.json.js';
import es from '../lang/es.json.js';
import he_IL from '../lang/he_IL.json.js';
import fr from '../lang/fr.json.js';
import pt_BR from '../lang/pt_BR.json.js';
import de from '../lang/de.json.js';
import it from '../lang/it.json.js';
import ja from '../lang/ja.json.js';
import ko from '../lang/ko.json.js';
import zh_TW from '../lang/zh-TW.json.js';
import cs from '../lang/cs.json.js';
import da from '../lang/da.json.js';
import id from '../lang/id.json.js';
import lt from '../lang/lt.json.js';
import hu from '../lang/hu.json.js';
import nl from '../lang/nl.json.js';
import nb from '../lang/nb.json.js';
import pl from '../lang/pl.json.js';
import ro from '../lang/ro.json.js';
import fi from '../lang/fi.json.js';
import sv from '../lang/sv.json.js';
import tr from '../lang/tr.json.js';
import el from '../lang/el.json.js';
import ru from '../lang/ru.json.js';
import bg from '../lang/bg.json.js';
import hi from '../lang/hi.json.js';
import th from '../lang/th.json.js';
import zh_CN from '../lang/zh-CN.json.js';
import pt from '../lang/pt.json.js';

var initI18nUiComponent = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (language) {
        if (language === void 0) { language = "en"; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (i18next.isInitialized) {
                        i18next.changeLanguage(language);
                        return [2 /*return*/, i18next];
                    }
                    return [4 /*yield*/, i18next.use(HttpBackend).init({
                            lng: language,
                            fallbackLng: "en",
                            resources: {
                                en: {
                                    translation: en,
                                },
                                es: {
                                    translation: es,
                                },
                                he_IL: {
                                    translation: he_IL,
                                },
                                fr: {
                                    translation: fr,
                                },
                                "pt-BR": {
                                    translation: pt_BR,
                                },
                                pt: {
                                    translation: pt,
                                },
                                de: {
                                    translation: de,
                                },
                                it: {
                                    translation: it,
                                },
                                ja: {
                                    translation: ja,
                                },
                                ko: {
                                    translation: ko,
                                },
                                "zh-TW": {
                                    translation: zh_TW,
                                },
                                cs: {
                                    translation: cs,
                                },
                                da: {
                                    translation: da,
                                },
                                id: {
                                    translation: id,
                                },
                                lt: {
                                    translation: lt,
                                },
                                hu: {
                                    translation: hu,
                                },
                                nl: {
                                    translation: nl,
                                },
                                nb: {
                                    translation: nb,
                                },
                                pl: {
                                    translation: pl,
                                },
                                ro: {
                                    translation: ro,
                                },
                                fi: {
                                    translation: fi,
                                },
                                sv: {
                                    translation: sv,
                                },
                                tr: {
                                    translation: tr,
                                },
                                el: {
                                    translation: el,
                                },
                                ru: {
                                    translation: ru,
                                },
                                bg: {
                                    translation: bg,
                                },
                                hi: {
                                    translation: hi,
                                },
                                th: {
                                    translation: th,
                                },
                                "zh-CN": {
                                    translation: zh_CN,
                                },
                            },
                            interpolation: {
                                escapeValue: false,
                            },
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, i18next];
            }
        });
    });
};
var t = function (key, options) {
    return (i18next.t(key, options) || key);
};
var RTL_LANGUAGES = ["ar", "he", "he_IL", "fa", "ur", "yi"];
var getDirection = function (language) {
    var currentLanguage = language || i18next.language || "en";
    return RTL_LANGUAGES.includes(currentLanguage) ? "rtl" : "ltr";
};
var getCurrentLanguage = function () {
    return i18next.language || "en";
};

export { getCurrentLanguage, getDirection, initI18nUiComponent, t };
//# sourceMappingURL=i18n.js.map
